export const getAfterpayIneligibleStates = (state) => {
  return (
    state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.AFTERPAY_INELIGIBLE_STATES
  );
};
export default getAfterpayIneligibleStates;
